const stringMatchAllPolyfill = () => {
  if (!String.prototype.matchAll) {
    // eslint-disable-next-line no-extend-native
    String.prototype.matchAll = function (regexp) {
      if (regexp instanceof RegExp && !regexp.global) {
        throw new TypeError(
          'RegExp passed into String.prototype.matchAll() must have global tag.',
        );
      }
      var /** !RegExp */ regexCopy = new RegExp(
          regexp,
          regexp instanceof RegExp ? undefined : 'g',
        );
      var matchString = this;
      var /** boolean */ finished = false;
      var matchAllIterator = {
        next: function () {
          if (finished) {
            return { value: undefined, done: true };
          }

          var match = regexCopy.exec(matchString);
          if (!match) {
            finished = true;
            return { value: undefined, done: true };
          }
          if (match[0] === '') {
            /**
             * See https://262.ecma-international.org/10.0/#sec-advancestringindex
             * and
             * https://github.com/ljharb/String.prototype.matchAll/blob/5e1a234e65d03e5312ea1d3cb617444f4ffa6e23/helpers/RegExpStringIterator.js#L71
             *
             * matchAll() is not allowed to get "stuck" returning an empty
             * string match infinitely, so we must make sure lastIndex always
             * increases.
             *
             * Also assume that `fullUnicode === false`. Any browser that supports
             * unicode regexes should not need this polyfill.
             */
            regexCopy.lastIndex += 1;
          }

          return { value: match, done: false };
        },
      };
      matchAllIterator[Symbol.iterator] = function () {
        return matchAllIterator;
      };
      return /**@type {!IteratorIterable<!RegExpResult>}> */ (matchAllIterator);
    };
  }
};

const applyPolyfills = () => {
  stringMatchAllPolyfill();
};

export default applyPolyfills;
